import React, { Component } from 'react';
import './GenerarPedido.css'

import { Button, Row, Spin, Icon, Table, InputNumber, Modal, Col, Tooltip, Input } from 'antd';

import { openNotification } from '../../util/notificaciones';
import PedidosAuxiliaresRequest from '../../services/PedidosAuxiliares';
import PedidosRequest from '../../services/Pedidos';
import { sanitizerTexto }   from '../../util/utilerias';
import ResponsiveCard from '../Common/ResponsiveCard';
const { confirm } = Modal;

/**
 * Clase para ver el proceso de modelo de pedido Auxiliar
 */
export default class GenerarPedidoAuxiliar extends Component {

    state = {
        cargando:false,
        bloquearGenerar: true,
        arrArticulosAux: [],
        arrArticulosAuxCopy: [],
        scroll: { y: 500 },
        sitio_id: null,
        procesando: false
    }

    changeScrollHeight = () => {
        let state = { ...this.state }
        let width = window.innerWidth;

        if (width <= 800) {
            state.scroll = {
                y: 330,
            };
        } else {
            state.scroll = {
                y: 500,
            };
        }

        this.setState(state);
    }

    componentWillMount = () => {
        this.changeScrollHeight();
    }

    /**
     * Función que se ejecuta cuando se cargan los datos
     */
    componentDidMount = () => {
        let state = { ...this.state }

        // listeners
        window.addEventListener("resize", this.changeScrollHeight);

        let rol = localStorage.getItem("role");
        let rol_supervisor = rol === "Supervisor de Operaciones Drive" ? true : false;
        
        this.setState(state, () => {
                PedidosRequest.ListarSitiosSupervisor()
                .then(response => {
                    state.sitio_id = response.data.sitio[0].id
                    this.setState(state);
                })
                .catch(err => {
                    openNotification(
                        "Ha ocurrido un error al listar los sitios del supervisor.",
                        "Error al listar sitios",
                        false
                    )
                });
        });

        if (rol_supervisor) {

        }
        else {
            this.setState({ cargando: true }, () => {
                PedidosAuxiliaresRequest.CargarArticulos()
                    .then(response => {
                        response.data.forEach(element => {
                            element.cantidad = 0
                        });

                        state.arrArticulosAux = response.data;
                        state.arrArticulosAuxCopy = response.data;
                        state.cargando = false;
                        state.bloquearGenerar = false;
                        this.setState(state);
                    })
                    .catch(err => {
                        openNotification(
                            err?.response?.data?.cuerpo,
                            "Error al listar artículos",
                            false
                        )
                        this.setState({ cargando: false, bloquearGenerar: true })
                    })
            });
        }
    }

    componentWillUnmount = () => {
        window.removeEventListener("resize", this.changeScrollHeight);
    }

    /**
     * Función que se ejecuta cuando se cambia la cantidad de un artículo
     * @param: cantidad. valor del input
     * @param: record. item del input
     */
    onChangeCantArticulo = (cantidad, record) => {
        let state = { ...this.state }
        let cambio = false;
        if (cantidad === "" || cantidad === undefined) cantidad = 0;
        cantidad = Math.round(cantidad)

        state.arrArticulosAux.forEach(element => {
            if (element.articulo_id === record.articulo_id) {
                element.cantidad = cantidad;
                cambio = true
            }
        });

        if (cambio) {
            setTimeout(() => { this.setState(state) }, 1500)
        } else {
            this.setState(state)
        }
    }

    /**
     * Función que se ejecuta cuando el usuario introduce algo en la barra de búsqueda
     * @param: value. valor de la búsqueda
     * @return: nada. se establece un nuevo valor para el texto a filtrar.
     */
    filterText = (value) => {
        let state = { ...this.state };
        state.filterText = value;
        let arrArticulosAuxCopy = state.arrArticulosAux
        if (value) {
            arrArticulosAuxCopy = arrArticulosAuxCopy.filter(obj => {
                return sanitizerTexto(value, obj.codigo)
                    || sanitizerTexto(value, obj.descripcion)
            })
        }
        state.arrArticulosAuxCopy = arrArticulosAuxCopy;
        this.setState(state);
    }


    /**
     * Función que se ejecuta cuando se confirma edición de usuario
     * @return: nada.
     */
    showConfirm = () => {
        confirm({
            title: 'Confirmar',
            content: <div><b>¿Está seguro que las cantidades son correctas?</b> Se generará el pedido con las cantidades ingresadas.</div>,
            okText: 'Aceptar',
            cancelText: 'Cancelar',
            okButtonProps: {
                id: 'boton-aceptar-confirmacion-generar-pedido-tabla',
            },
            cancelButtonProps: {
                id: 'boton-cancelar-confirmacion-generar-pedido-tabla',
            },
            onOk: () => {
                this.setState({ cargando: true, bloquearBotones: true }, this.generarPedido)
            },
        });
    }

    /**
     * Función que se ejecuta cuando se confirma generar pedido
     * @return: nada.
     */
    generarPedido = () => {
        let state = { ...this.state }
        let objEnviar = {};
        state.procesando = true;

        objEnviar.articulos = state.arrArticulosAux.filter(item => item.cantidad > 0)
        objEnviar.sitio = state.sitio_id;

        const driveId = this.props.location.state?.drive_id;
        if(driveId != undefined && driveId != null)
        {
            objEnviar.sitio = driveId;
        }

        if(objEnviar.articulos.length){
            this.setState(state, () => {
                PedidosAuxiliaresRequest.GenerarPedidoAux(this.props.location.state.categoria_id, objEnviar)
                .then(response => {
                    state.bloquearBotones = false;
                    state.cargando = false;
                    state.procesando = false;
                    this.setState(state, this.props.history.goBack())
                    openNotification(
                        response.data.cuerpo,
                        response.data.titulo,
                        true
                    );
                })
                .catch(err => {
                    this.setState({ bloquearBotones: false, cargando: false, procesando: false });
                    openNotification(
                        err.response.data.cuerpo,
                        err.response.data.titulo,
                        false
                    );
                });
            });
        }
        else {
            this.setState({ bloquearBotones: false, cargando: false });
            openNotification(
                "Ingrese cantidad en al menos un artículo.",
                "Error al generar pedido",
                false
            )
        }
    }

    render() {
        const columnasArticulos = [
            {
                title: "Código",
                dataIndex: "codigo",
                key: "codigo",
                width: 110,
                show: true
            },
            {
                title: "Nombre",
                dataIndex: "descripcion",
                key: "descripcion",
                width: 220,
                show: true,
                className: 'nombreColumn',
                render: (value, record) => (
                    <Tooltip title={value} placement='top'>{value}</Tooltip>
                )
            },
            {
                title: "UDC",
                dataIndex: "unidad_compra",
                key: "unidad_compra",
                width: 110,
                show: true,
            },
            {
                title: "Cantidad",
                dataIndex: "cantidad",
                key: "cantidad",
                width: 110,
                align: 'center',
                show: true,
                render: (value, record) => (
                    <InputNumber
                        type="number"
                        formatter={value => String(value).replace(/[,.-]$/, '')}
                        parser={value => String(value).replace(/[,.-]$/, '')}
                        min={0}
                        maxLength={7}
                        onWheel={(e) => e.target.blur()}
                        onChange={(cantidad) => this.onChangeCantArticulo(cantidad, record)}
                        value={record.cantidad}
                    />
                )
            },
        ]
        let columnasTabla = columnasArticulos.filter(obj => obj.show === true)

        return (
            <ResponsiveCard
                id="ParentSize"
                className='generarPedido'
                title="Módulo generar pedido"
                extra={
                    <div>
                        <Button
                            id="boton-atras-generar-pedido"
                            className="btnCancelar"
                            key="back"
                            style={{ marginRight: "10px" }}
                            onClick={() => {
                                this.props.history.goBack()
                            }}
                        >
                            Atrás
                        </Button>
                        <Button
                            id="boton-generar-pedido-tabla"
                            type="primary"
                            disabled={this.state.bloquearGenerar}
                            loading={this.state.procesando}
                            onClick={() => {
                                this.showConfirm()
                            }}
                        >
                            Generar pedido
                        </Button>
                    </div>
                }
            >
                <div className="panel-block">
                    <div>
                        <Row gutter={12}>
                            <Col span={12}>
                                <div className="center">Búsqueda:</div>
                                <Tooltip
                                    placement="top"
                                    title="Buscar por Código / Nombre">
                                    <Input
                                        autoFocus={true}
                                        maxLength={50}
                                        id="input-buscar-articulos-generar-pedido"
                                        placeholder="Buscar por Código / Nombre"
                                        onChange={(e) => this.filterText(e.currentTarget.value)}
                                        value={this.state.filterText}
                                    />
                                </Tooltip>
                            </Col>
                        </Row>
                        <br />
                        <Spin
                            spinning={this.state.cargando}
                            tip="Cargando..."
                            indicator={<Icon type="loading" style={{ fontSize: 24, color: "#e0cbae" }} spin />}
                            style={{ color: "#e0cbae", backgroundColor: "rgb(255,255,255,0.8)" }}
                        >
                            <Table
                                size="small"
                                locale={{ emptyText: 'No se han encontrado resultados.' }}
                                rowKey={(articulos, index) => index}
                                columns={columnasTabla}
                                pagination={false}
                                scroll={this.state.scroll}
                                dataSource={this.state.arrArticulosAuxCopy}
                            />
                        </Spin>
                    </div>
                </div>
            </ResponsiveCard>
        );
    }
}